<template>
    <div v-show="loggedInStatus" class="h-12">
        <nav class="w-full bg-gray-200 shadow text-center fixed z-40">
            <div class="container flex flex-wrap max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                <div v-show="routeName !== '/'">
                    <button @click="previousPage" class="w-10 h-full">
                        <i class="material-icons leading-tight text-3xl text-mimer-turquoise">chevron_left</i>
                    </button>
                </div>

                <div class="flex flex-wrap flex-grow flex-row-reverse">
                    <button role="button" class="inline-block unstyled-link p-2" @click="invalidateSession(true)">
                        <i
                            class="relative material-icons relative text-3xl text-mimer-turquoise"
                            style="top: 10px; padding-right: 3px"
                            >logout</i
                        >
                        <span class="">Logga ut</span>
                    </button>
                    <router-link
                        role="button"
                        class="inline-block unstyled-link p-2"
                        :to="'/synkronisering?forced=true'">
                        <i
                            class="relative material-icons relative text-3xl text-mimer-turquoise"
                            style="top: 10px; padding-right: 3px"
                            >refresh</i
                        >
                        <span class="">Ladda om sida</span>
                    </router-link>
                    <router-link role="button" class="inline-block unstyled-link p-2" :to="'/profil'">
                        <i
                            class="relative material-icons relative text-3xl text-mimer-turquoise"
                            style="top: 10px; padding-right: 3px"
                            >account_circle</i
                        >
                        <span class="">Min profil</span>
                    </router-link>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import { authStore } from '../../stores/auth';
import { useRoute } from 'vue-router';
import { mapState } from 'pinia';

export default {
    name: 'PageSubHeader',

    computed: {
        ...mapState(authStore, { loggedInStatus: 'loggedInStatus', invalidateSession: 'invalidateSession' }),

        routeName() {
            return useRoute()?.path;
        },
    },

    methods: {
        previousPage() {
            history.back();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
